import { DetailTotalData } from "src/api/contract/contract-types";
import ContractBillingSchedule from "src/pages/contract/commonComponents/ContractBillingSchedule";
import ContractBillingScheduleNoti from "src/pages/contract/commonComponents/ContractBillingScheduleNoti";
import ContractBuildingManagement from "src/pages/contract/commonComponents/ContractBuildingManagement";
import ContractInfo from "src/pages/contract/commonComponents/ContractInfo";
import ContractorAndOrganization from "src/pages/contract/commonComponents/ContractorAndOrganization";
import ContractBillingSubject from "src/pages/contract/commonComponents/ContractBillingSubject";
import ContractTaxInvoiceSection from "src/pages/contract/commonComponents/editComponent/ContractTaxInvoiceSection";
import ContractCreditManagement from "src/pages/contract/commonComponents/reservation/ContractCreditManagement";

interface ContractBasicProp {
  detailData: DetailTotalData; //상품 상세 조회 정보
  setData: Function;
}
const FOType = ({ detailData, setData }: ContractBasicProp) => {
  return (
    <>
      {/* 계약자 관리자 정보 */}
      <ContractorAndOrganization detailData={detailData} setData={setData} />
      {/* 계약 청구 주제 */}
      <ContractBillingSubject detailData={detailData} setData={setData} />
      {/* 계약 정보 */}
      <ContractInfo detailData={detailData} setData={setData} />
      {/* 이용료 결제 정보 */}
      <ContractBillingSchedule detailData={detailData} setData={setData} />
      {/* 안내문 설정 */}
      <ContractBillingScheduleNoti detailData={detailData} setData={setData} />

      {/* 세금계산서 발행 설정 */}
      <ContractTaxInvoiceSection detailData={detailData} setData={setData} />
      {/* 충전금 관리 (공간임대 계약) */}
      <ContractCreditManagement detailData={detailData} />

      {/* 건물 운영 관리 */}
      <ContractBuildingManagement detailData={detailData} setData={setData} />
    </>
  );
};

export default FOType;
